import { FC, useState } from 'react';

import { PlusCircleOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import { articleCategoryDeleteMessage } from 'common/constants';
import { IArticleCategory } from 'common/types';
import { useModal } from 'common/utils';
import { actions, Table, text } from 'components/Table';
import { observer } from 'mobx-react-lite';
import { ArticleCategoryModel } from 'store/article-categoriy-model';

import { ArticleCategoriesViewModel } from './article-category-view-model';
import { ArticleCategoryModal } from './ArticleCategoriesModal';

import styles from './styles.module.scss';

export interface IArticleCategoriesProps {
  model: ArticleCategoriesViewModel;
}

const ArticleCategories: FC<IArticleCategoriesProps> = observer(({ model }) => {
  const [isOpen, openModal, closeModal] = useModal(false);
  const [editableArticleCategory, setEditableArticleCategory] =
    useState<ArticleCategoryModel | null>(null);

  const handleEdit = (id: IArticleCategory['id']) => {
    const selectedArticleCategory = model.articleCategories.find(
      (articleCategory) => articleCategory.id === id,
    );

    if (selectedArticleCategory) {
      setEditableArticleCategory(selectedArticleCategory);
    }

    openModal();
  };

  const handleCloseModal = () => {
    closeModal();

    setEditableArticleCategory(null);
  };

  const columns = [
    text({
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      loading: model.loading,
      width: '90%',
    }),
    actions({
      onEdit: handleEdit,
      onDelete: model.removeArticleCategory,
      disabled: model.loading,
      deleteMessage: articleCategoryDeleteMessage,
      width: '5%',
    }),
  ];

  return (
    <div className={styles.articleCategoryPage}>
      <Typography.Title level={1}>Article categories</Typography.Title>
      <div className={styles.header}>
        <Button
          type="primary"
          icon={<PlusCircleOutlined />}
          size="middle"
          onClick={openModal}
        >
          Add category
        </Button>
      </div>
      <Table
        bordered
        loading={model.loading}
        skeleton={model.skeleton}
        data={model.articleCategories}
        columns={columns}
      />
      <ArticleCategoryModal
        model={model}
        closeModal={handleCloseModal}
        editableArticleCategory={editableArticleCategory}
        isOpen={isOpen}
      />
    </div>
  );
});

export const ArticleCategoriesPage = () => {
  const model = new ArticleCategoriesViewModel();

  return <ArticleCategories model={model} />;
};
